/**
 * Arthaus "In a room" grid view (Phase 10, HD-CO-ROOMVIEW)
 * docs/storefront-redesign/requirements/3_collections/HIGH_DESIGN_TRD.md
 *
 * Cards carry their in-room scene as data (data-hd-room / -srcset / -alt on [data-card];
 * see snippets/product-card.liquid and assets/arthaus-card.js). Nothing is downloaded
 * until a shopper picks "In a room" — then each card gains a second <img> that
 * crossfades over the artwork. Cards without a scene keep their artwork image.
 *
 * The server always renders the Artwork view (LCP-safe, rule X-3). A saved preference
 * is re-applied only after the page has loaded. Cards inserted later (filters, load
 * more, concept chips) are picked up by a MutationObserver.
 *
 * Gated by [data-hd-room-view] on <html> (theme setting or ?hd=). Mode lives on
 * <html data-hd-view="room|art"> so CSS in hd-room-view.css drives the crossfade.
 */
(function () {
  'use strict';
  var root = document.documentElement;
  if (!root.hasAttribute('data-hd-room-view')) return;

  var KEY = 'hd-grid-view';
  var mode = 'art';
  var observer = null;

  function savedMode() { try { return localStorage.getItem(KEY) === 'room' ? 'room' : 'art'; } catch (e) { return 'art'; } }
  function save(m) { try { localStorage.setItem(KEY, m); } catch (e) {} }

  // Give one card its room image (once).
  function hydrate(card) {
    if (card.hasAttribute('data-hd-room-ready')) return;
    var src = card.getAttribute('data-hd-room');
    var media = card.querySelector('[data-card-media]');
    card.setAttribute('data-hd-room-ready', '');
    if (!src || !media) return;
    var img = document.createElement('img');
    img.className = 'hd-card__room';
    img.alt = '';                        // the artwork image already names the piece
    img.decoding = 'async';
    img.loading = 'lazy';
    var srcset = card.getAttribute('data-hd-room-srcset');
    if (srcset) { img.srcset = srcset; img.sizes = card.getAttribute('data-hd-room-sizes') || '(min-width: 1024px) 25vw, (min-width: 768px) 33vw, 50vw'; }
    img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
    img.src = src;
    // Directly over the artwork image, beneath the badge/overlay that follow it.
    var base = media.querySelector('img');
    if (base) base.insertAdjacentElement('afterend', img); else media.insertBefore(img, media.firstChild);
  }

  function hydrateAll(scope) {
    (scope || document).querySelectorAll('[data-card][data-hd-room]:not([data-hd-room-ready])').forEach(hydrate);
  }

  function watch() {
    if (observer || !('MutationObserver' in window)) return;
    var queued = false;
    observer = new MutationObserver(function () {
      if (queued || mode !== 'room') return;
      queued = true;
      requestAnimationFrame(function () { queued = false; hydrateAll(); });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function syncControls() {
    document.querySelectorAll('[data-hd-view-toggle] [data-view]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-view') === mode ? 'true' : 'false');
    });
  }

  function apply(m, opts) {
    mode = m === 'room' ? 'room' : 'art';
    root.setAttribute('data-hd-view', mode);
    syncControls();
    if (mode === 'room') { hydrateAll(); watch(); }
    if (opts && opts.persist) {
      save(mode);
      if (window.posthog && window.posthog.capture) {
        try { window.posthog.capture('hd_view_mode', { surface: 'collection', mode: mode }); } catch (e) {}
      }
    }
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-hd-view-toggle] [data-view]');
    if (!b) return;
    apply(b.getAttribute('data-view'), { persist: true });
  });

  function init() {
    syncControls();
    if (savedMode() !== 'room') return;
    // Re-apply after load so the preference never competes with LCP.
    var go = function () { apply('room'); };
    if (document.readyState === 'complete') go();
    else window.addEventListener('load', go, { once: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.ArthausRoomView = { apply: apply, hydrate: hydrateAll };
})();
